import React, { useState, useEffect } from 'react'; 
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, FlatList } from 'react-native';
import { collection, query, where, onSnapshot, setDoc, doc, getDocs } from 'firebase/firestore';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { db, auth } from '../firebaseConfig';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { KeyboardAvoidingView, Platform, } from 'react-native';


const MotoboyGainsScreen = ({ navigation }) => {
  const [gains, setGains] = useState([]);
  const [totalGain, setTotalGain] = useState(0);
  const [completedOrdersCount, setCompletedOrdersCount] = useState(0);
  const [reports, setReports] = useState([]);
  const [dayGains, setDayGains] = useState([]);
  const [locationTotals, setLocationTotals] = useState({ setor: 0, bairro: 0, extra: 0, });
  const [totalRoutesValue, setTotalRoutesValue] = useState(0);

  const daysOfWeek = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];

  useEffect(() => {
  navigation.setOptions({ headerShown: false });

  const user = auth.currentUser;
  if (!user) {
    console.error("Usuário não autenticado");
    return;
  }

  const { startDate, endDate } = getCurrentWeekRange();

  const pedidosQuery = query(
    collection(db, 'pedido'),
    where('motoboyId', '==', user.uid),
    where('status', '==', 'completed')
  );

  const unsubscribePedidos = onSnapshot(pedidosQuery, async (snapshot) => {
    // --- APENAS UM console.log para teste! ---
    // console.log("Semana calculada:", startDate.toLocaleDateString(), "-", endDate.toLocaleDateString());
    // console.log("Número de pedidos encontrados:", snapshot.docs.length);

    let gainsArray = [];
    snapshot.docs.forEach((doc) => {
      const data = doc.data();
      let completedDate = null;
      if (data.completedAt && typeof data.completedAt.toDate === "function") {
        completedDate = new Date(data.completedAt.toDate());
        // console.log("Pedido encontrado - Data de conclusão:", completedDate);
      }
      const gainValue = parseFloat(data.locationValue || 0);
      const locationType = data.locationType ? data.locationType.toLowerCase() : 'extra';
      if (gainValue > 0 && completedDate) {
        gainsArray.push({
          date: completedDate,
          gainValue,
          locationType,
        });
      }
    });

    // Filtrar ganhos que pertencem à semana atual
    const filteredGains = gainsArray.filter(({ date }) => date && date >= startDate && date <= endDate);
    const totalGainsValue = filteredGains.reduce((sum, gain) => sum + gain.gainValue, 0);
    const completedOrdersCount = filteredGains.length;

    calculateLocationTotals(filteredGains);
    setGains(filteredGains);
    setTotalGain(totalGainsValue);
    setCompletedOrdersCount(completedOrdersCount);
    setDayGains(calculateGainsByDay(filteredGains));
    await checkNewWeekAndResetGains(user.uid, totalGainsValue, completedOrdersCount);
  });

  // Relatórios semanais
  const reportsQuery = query(collection(db, 'weeklyMotoboyReports', user.uid, 'reports'));
  const unsubscribeReports = onSnapshot(reportsQuery, (snapshot) => {
    const uniqueReports = {};
    snapshot.forEach(doc => {
      const data = doc.data();
      const startDate = new Date(data.startDate.seconds * 1000);
      const reportId = `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
      if (!uniqueReports[reportId]) {
        uniqueReports[reportId] = {
          ...data,
          id: doc.id,
          startDate: formatDate(startDate),
          endDate: formatDate(new Date(data.endDate.seconds * 1000)),
        };
      }
    });
    setReports(Object.values(uniqueReports));
  });

  return () => {
    unsubscribePedidos();
    unsubscribeReports();
  };

}, []);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;
  
    const fetchGainsData = async () => {
      const { startDate, endDate } = getCurrentWeekRange();
      let gainsArray = [];
      let totalRoutes = 0;
  
      // Consultar pedidos
      const pedidosQuery = query(
        collection(db, 'pedido'),
        where('motoboyId', '==', user.uid),
        where('status', '==', 'completed')
      );
  
      const pedidosSnapshot = await getDocs(pedidosQuery);
      pedidosSnapshot.forEach((doc) => {
        const data = doc.data();
        const completedDate = data.completedAt ? new Date(data.completedAt.toDate()) : null;
  
        gainsArray.push({
          date: completedDate,
          gainValue: parseFloat(data.locationValue || 0),
          locationType: data.locationType ? data.locationType.toLowerCase() : 'extra',
        });
      });
  
      // Consultar rotas
      const routesQuery = query(
        collection(db, 'routes'),
        where('motoboyId', '==', user.uid),
        where('status', '==', 'completed')
      );
  
      const routesSnapshot = await getDocs(routesQuery);
      routesSnapshot.forEach((doc) => {
        const data = doc.data();
        const completedDate = data.completedAt
          ? new Date(data.completedAt.toDate())
          : new Date();
  
        if (completedDate >= startDate && completedDate <= endDate) {
          totalRoutes += parseFloat(data.totalValue || 0);
        }
  
        gainsArray.push({
          date: completedDate,
          gainValue: parseFloat(data.totalValue || 0),
          locationType: 'rota',
        });
      });
  
      // Atualizar os estados
      const filteredGains = gainsArray.filter(
        ({ date }) => date && date >= startDate && date <= endDate
      );
      setGains(filteredGains);
      setTotalGain(filteredGains.reduce((sum, gain) => sum + gain.gainValue, 0));
      setCompletedOrdersCount(filteredGains.length);
      setTotalRoutesValue(totalRoutes);
      calculateLocationTotals(filteredGains);
    };
  
    fetchGainsData();
  }, []);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          console.error("Usuário não autenticado");
          return;
        }
  
        const { startDate, endDate } = getCurrentWeekRange();
  
        // Query para pedidos
        const ordersQuery = query(
          collection(db, 'pedido'),
          where('motoboyId', '==', user.uid),
          where('status', '==', 'completed')
        );
        const ordersSnapshot = await getDocs(ordersQuery);
  
        // Query para rotas
        const routesQuery = query(
          collection(db, 'routes'),
          where('motoboyId', '==', user.uid),
          where('status', '==', 'completed')
        );
        const routesSnapshot = await getDocs(routesQuery);
  
        // Combinar ganhos de pedidos e rotas
        const gainsArray = [
          ...ordersSnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              date: data.completedAt ? new Date(data.completedAt.toDate()) : null,
              gainValue: parseFloat(data.locationValue || 0),
              locationType: data.locationType ? data.locationType.toLowerCase() : 'extra',
            };
          }),
          ...routesSnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              date: data.completedAt ? new Date(data.completedAt.toDate()) : null,
              gainValue: parseFloat(data.totalValue || 0),
              locationType: 'rota',
            };
          }),
        ];
  
        // Filtrar ganhos pela semana atual
        const filteredGains = gainsArray.filter(({ date }) => date && date >= startDate && date <= endDate);
  
        // Calcular ganhos diários
        const dailyTotals = calculateDailyTotals(filteredGains);
  
        // Atualizar estados
        setDayGains(dailyTotals);
        setTotalGain(filteredGains.reduce((sum, { gainValue }) => sum + gainValue, 0));
        setCompletedOrdersCount(filteredGains.length);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
  
    fetchData();
  }, []);
  
    
  const calculateGainsByDay = (gainsArray) => {
    const dayGains = Array(7).fill(0);
    gainsArray.forEach((gain) => {
      if (gain.date) {
        const day = gain.date.getDay() === 0 ? 6 : gain.date.getDay() - 1;
        dayGains[day] += gain.gainValue;
      }
    });

    return dayGains;
  };

  const formatDate = (date) => {
    if (isNaN(date.getTime())) {
      return "Data Inválida";
    }
    return date.toLocaleDateString('pt-BR');
  };

  const calculateLocationTotals = (gainsArray) => {
    const totals = { setor: 0, bairro: 0, extra: 0 };
  
    gainsArray.forEach(({ locationType, gainValue }) => {
      if (locationType === 'setor') {
        totals.setor += gainValue || 0;
      } else if (locationType === 'bairro') {
        totals.bairro += gainValue || 0;
      } else {
        totals.extra += gainValue || 0;
      }
    });
  
    setLocationTotals(totals); // Atualiza o estado com os totais calculados
  };
  
  
  const calculateDailyTotals = (gainsArray) => {
    // Inicializa os totais diários para cada dia da semana
    const dailyTotals = {
      Seg: 0,
      Ter: 0,
      Qua: 0,
      Qui: 0,
      Sex: 0,
      Sáb: 0,
      Dom: 0,
    };
  
    // Processa cada ganho
    gainsArray.forEach(({ date, gainValue }) => {
      if (date) {
        const dayIndex = date.getDay(); // Domingo é 0, Segunda é 1, etc.
        const dayOfWeek = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'][dayIndex];
        dailyTotals[dayOfWeek] += gainValue || 0; // Soma os ganhos ao total do dia
      }
    });
  
    return dailyTotals;
  };  
  
  const getCurrentWeekRange = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 = Domingo, 1 = Segunda, ..., 6 = Sábado
  
    // Calcular o início da semana (segunda-feira)
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
    startDate.setHours(0, 0, 0, 0);
  
    // Calcular o final da semana (domingo)
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    endDate.setHours(23, 59, 59, 999);
  
    console.log("Semana calculada:", startDate.toLocaleDateString(), "-", endDate.toLocaleDateString());
    return { startDate, endDate };
  };
  
  const saveWeeklyReport = async (userId, startDate, endDate, totalGain, completedOrdersCount) => {
    const reportId = `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}_${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
    const reportRef = doc(db, 'weeklyMotoboyReports', userId, 'reports', reportId);

    try {
      await setDoc(reportRef, {
        startDate: startDate,
        endDate: endDate,
        totalGain: totalGain,
        completedOrdersCount: completedOrdersCount,
      });
      console.log("Relatório semanal salvo com sucesso:", reportId);
    } catch (error) {
      console.error("Erro ao salvar relatório semanal:", error);
    }
  };

  const checkNewWeekAndResetGains = async (userId, totalGain, completedOrdersCount) => {
    const { startDate, endDate } = getCurrentWeekRange();
    const lastSavedDate = await AsyncStorage.getItem('lastSavedDate');

    if (lastSavedDate !== formatDate(startDate)) {
      await saveWeeklyReport(userId, startDate, endDate, totalGain, completedOrdersCount);

      setTotalGain(0);
      setCompletedOrdersCount(0);
      setDayGains(Array(7).fill(0));
      setGains([]);
      
      await AsyncStorage.setItem('lastSavedDate', formatDate(startDate));
      console.log("Nova semana iniciada. Ganhos reiniciados.");
    }
  };

  const { startDate, endDate } = getCurrentWeekRange();

  const maxGain = 5000;
  const chartHeight = 200;

  return (
  <View style={{ flex: 1, backgroundColor: '#2c5364' }}>
    {/* Parte Fixa: Cabeçalho e Gráfico */}
    <View style={styles.fixedContainer}>
      {/* Botão Voltar */}
      <TouchableOpacity
        style={styles.backButtonContainer}
        onPress={() => navigation.goBack()}
      >
        <Icon name="arrow-back" size={24} color="#FFF" />
      </TouchableOpacity>

      {/* Período da Semana */}
      <Text style={styles.dateRange}>
        {formatDate(startDate)} - {formatDate(endDate)}
      </Text>

      {/* Ganho Total */}
      <Text style={styles.totalGain}>
        Ganhos: R$ {(totalGain + totalRoutesValue).toFixed(2)}
      </Text>

      {/* Gráfico de Barras */}
      <View style={styles.chartContainer}>
        {Object.entries(dayGains).map(([day, total], index) => (
          <View key={index} style={styles.barWrapper}>
            <View style={styles.barContainer}>
              <View
                style={[
                  styles.bar,
                  { height: (Math.min(total, maxGain) / maxGain) * chartHeight || 0 },
                ]}
              />
              <Text
                style={[
                  styles.barValue,
                  { bottom: (Math.min(total, maxGain) / maxGain) * chartHeight + 5 },
                ]}
              >
                R$ {total.toFixed(2)}
              </Text>
            </View>
            <Text style={styles.barLabel}>{day}</Text>
          </View>
        ))}
      </View>
    </View>

    {/* Parte Rolável: Detalhes e Histórico */}
    <FlatList
      data={reports}
      keyExtractor={(item) => item.id}
      contentContainerStyle={styles.scrollContainer}
      ListHeaderComponent={
        <>
          {/* Detalhes dos Ganhos */}
          <View style={styles.detailContainer}>
            <Text style={styles.detailItem}>
              Pedidos Concluídos: {completedOrdersCount}
            </Text>
            <Text style={styles.detailItem}>
              Ganhos da semana: R$ {(totalGain + totalRoutesValue).toFixed(2)}
            </Text>
            <Text style={styles.detailItem}>
              Total Setor: R$ {locationTotals.setor.toFixed(2)}
            </Text>
            <Text style={styles.detailItem}>
              Total Bairro: R$ {locationTotals.bairro.toFixed(2)}
            </Text>
            <Text style={styles.detailItem}>
              Total Extra: R$ {locationTotals.extra.toFixed(2)}
            </Text>
          </View>
          {/* Histórico de Relatórios - título */}
          <View style={styles.historyContainer}>
            <Text style={styles.historyTitle}>Histórico de Semanas</Text>
          </View>
        </>
      }
      renderItem={({ item }) => (
        <View style={styles.reportItem}>
          <Text style={styles.reportText}>
            Semana: {item.startDate} - {item.endDate}
          </Text>
          <Text style={styles.reportText}>
            Ganho total: R$ {item.totalGain.toFixed(2)}
          </Text>
          <Text style={styles.reportText}>
            Pedidos Concluídos: {item.completedOrdersCount}
          </Text>
        </View>
      )}
      ListFooterComponent={<View style={{ height: 40 }} />}
      showsVerticalScrollIndicator={false}
    />
  </View>
);
};

const styles = StyleSheet.create({
  fixedContainer: {
    padding: 16,
    backgroundColor: '#203a43',
    borderBottomWidth: 1,
    borderBottomColor: '#00FF9D', // Linha para separar as seções
    paddingTop: 90, // Espaço extra no topo
  },  
  scrollContainer: {
    flexGrow: 1,
    alignItems: 'center',
    paddingBottom: 20,
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#203a43',
    paddingTop: 100, // Adicione espaço extra no topo
  },  
  backButtonContainer: {
    position: 'absolute',
    top: 80, // Ajuste o posicionamento superior
    left: 40,
    zIndex: 10,
    backgroundColor: '#2c5364',
    padding: 10,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOpacity: 0.3,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },  
  dateRange: {
    fontSize: 16,
    color: '#FFF',
    textAlign: 'center',
    marginTop: 10,
  },
  totalGain: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#FFF',
    textAlign: 'center',
    marginVertical: 12,
  },
  chartContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 200,
    width: '100%',
    paddingHorizontal: 0,
    marginVertical: 16,
  },
  barWrapper: {
    alignItems: 'center',
    marginHorizontal: 0,
  },
  barContainer: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
    position: 'relative',
    width: 48,
  },
  bar: {
    backgroundColor: '#00FF9D', // Cor neon para barras
    width: 15,
    borderRadius: 4,
  },
  barLabel: {
    color: '#FFF',
    marginTop: 4,
    fontSize: 12,
  },
  barValue: {
    color: '#FFF',
    position: 'absolute',
    fontSize: 12,
    width: '100%',
    textAlign: 'center',
  },
  detailContainer: {
    backgroundColor: '#2c5364',
    borderRadius: 10,
    padding: 16,
    marginVertical: 16,
    width: '90%',
    shadowColor: '#000',
    shadowOpacity: 0.3,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  detailItem: {
    fontSize: 16,
    color: '#FFF',
    marginBottom: 8,
  },
  historyContainer: {
    width: '100%',
    paddingHorizontal: 16,
    marginTop: 16,
  },
  historyTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFF',
    marginBottom: 8,
    textAlign: 'center',
  },
  reportItem: {
    backgroundColor: '#203a43',
    padding: 16,
    borderRadius: 8,
    marginBottom: 12,
    shadowColor: '#00FF9D',
    shadowOpacity: 0.6,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  reportText: {
    fontSize: 16,
    color: '#FFF',
  },
});

export default MotoboyGainsScreen;
